module.exports = __webpack_public_path__ + "static/media/chasingstats.73a7d94e.svg";